// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Util from './lib/util';
import axios from 'axios';
import Article from "./modules/article.vue"
import VueLazyload from "vue-lazyload"

import "./style/main.scss";


Vue.config.productionTip = false;

import $ from "jquery";

Vue.debug = true;

Vue.prototype.$isDebug = true;      //是否debug，显示或者隐藏部分调试信息
//PC上不进行APP登录判断等，方便pc调试
Vue.use(VueLazyload , {
    silent : false ,
    //attempt : 1,    //
    adapter : {
        //lazyload 默认情况下回出现重复加载的问题，使用 css类进区分
        loaded (data){
            $(data.el).removeClass('preimg');
        }
    }
});
new Vue({
    el: '#app',
    components : {
        Article
    },
    template : `<Article />`
});



// WEBPACK FOOTER //
// ./src/main.js